'use strict';





const ComplianceDescriptions={
shiftStart:"Start of Shift",
shiftEnd:"End of Shift",
extendedShiftStart:"Start of Extended Shift",
extendedPeriodShiftCheck:"Extended Shift",
postFlightDuringExtendedShift:"Post Flight (Extended Shift)",
postFlightDuringNight:"Post Flight (Night)",
retakeTest:"Retake"};


module.exports=ComplianceDescriptions;
//# sourceMappingURL=complianceDescriptions.js.map
